const ALLOWED_INSPECTION_TYPE_IDS = ['c9ab83f8-d83e-4b7c-a43d-76e7893906ba', '248481d4-dba0-4815-b59d-a34dd613a360'];

const canShowInspectionDescription = inspectionTypeId => {
  const id = `${inspectionTypeId ?? ''}`.toLowerCase();
  return ALLOWED_INSPECTION_TYPE_IDS.includes(id);
};

const normalizeInspectionDescription = value => {
  if (value === 0 || value === '0' || value == null) return '';
  return `${value}`;
};

export const createInspectionsFormFields = (inspection, enumerations) => {
  const inspectionStatusOptions = enumerations?.inspectionStatuses?.length
    ? enumerations.inspectionStatuses.filter(s => s.isActive === true)
    : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const isDescriptionEditable = canShowInspectionDescription(inspection?.inspectionTypeId);

  const fields = [
    {
      header: 'Inspection Description',
      accessorKey: 'inspectionDescription',
      type: 'text',
      required: false,
      value: normalizeInspectionDescription(inspection?.inspectionDescription),
      tab: 1,
      hideInTable: !isDescriptionEditable,
      showWhen: () => isDescriptionEditable
    },
    {
      header: 'Ordered Date',
      accessorKey: 'orderedDate',
      type: 'date',
      required: false,
      value: inspection?.orderedDate,
      tab: 1
    },
    {
      header: 'Appointment Date',
      accessorKey: 'appointmentDate',
      type: 'date',
      required: false,
      value: inspection?.appointmentDate,
      tab: 1
    },
    {
      header: 'Received Date',
      accessorKey: 'receivedDate',
      type: 'date',
      required: false,
      value: inspection?.receivedDate,
      tab: 1
    },
    {
      header: 'Cancelled Date',
      accessorKey: 'cancelledDate',
      type: 'date',
      required: false,
      value: inspection?.cancelledDate,
      tab: 1
    },
    {
      header: 'Status',
      accessorKey: 'statusId',
      type: 'dropdown-v2',
      required: true,
      options: inspectionStatusOptions,
      value: inspection?.statusId,
      tab: 1
    },
    {
      header: 'Required By',
      accessorKey: 'requiredBy',
      type: 'text',
      required: false,
      value: inspection?.requiredBy ?? '',
      tab: 1
    },
    {
      header: 'Repair Amount',
      accessorKey: 'repairAmount',
      type: 'money',
      required: false,
      value: inspection?.repairAmount,
      tab: 1
    },
    {
      header: 'Repaired On',
      accessorKey: 'repairedDate',
      type: 'date',
      required: false,
      value: inspection?.repairedDate,
      tab: 1
    },
    {
      header: 'Amount to Deduct',
      accessorKey: 'deductFromEquity',
      type: 'money',
      required: false,
      value: inspection?.deductFromEquity,
      tab: 1
    },
    {
      header: 'Paid Date',
      accessorKey: 'paidDate',
      type: 'date',
      required: false,
      value: inspection?.paidDate,
      tab: 1
    },
    {
      header: 'Repairs Completed',
      accessorKey: 'areRepairsCompleted',
      type: 'checkbox',
      required: false,
      value: inspection?.areRepairsCompleted === true,
      tab: 1
    },
    {
      header: 'Receipts Received',
      accessorKey: 'areReceiptsReceived',
      type: 'checkbox',
      required: false,
      value: inspection?.areReceiptsReceived === true,
      tab: 1
    },
    {
      header: 'Morreale Notified',
      accessorKey: 'isMorrealeNotified',
      type: 'checkbox',
      required: false,
      value: inspection?.isMorrealeNotified === true,
      tab: 1
    },
    {
      header: 'Comments',
      accessorKey: 'comments',
      type: 'notes',
      required: false,
      value: inspection?.comments,
      tab: 1
    }
  ];
  return fields;
};

export const vendorSearchInfo = vendors => {
  return {
    searchingColumns: [
      { name: 'vendorId', title: 'Vendor Id' },
      { name: 'companyName', title: 'Company Name' },
      { name: 'city', title: 'City' },
      { name: 'state', title: 'State' },
      { name: 'phone', title: 'Company Phone' },
      { name: 'email', title: 'Company Email' }
    ],
    searchingColumnExtensions: [
      { columnName: 'vendorId', width: 150 },
      { columnName: 'companyName', width: 250 },
      { name: 'city', width: 175 },
      { name: 'state', width: 175 },
      { columnName: 'phone', width: 175 },
      { columnName: 'email', width: 175 }
    ],
    searchingRows: vendors,
    idKey: 'vendorId',
    nameKey: 'companyName'
  };
};

export const createNewInspectionsFormFields = (vendors, enumerations) => {
  const inspections = enumerations?.inspectionTypes?.length
    ? enumerations.inspectionTypes.filter(s => s.isActive === true)
    : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  return [
    {
      header: 'Inspection Type',
      accessorKey: 'inspectionTypeId',
      type: 'dropdown-v2',
      options: inspections,
      required: true,
      tab: 1
    },
    {
      header: 'Inspection Description',
      accessorKey: 'inspectionDescription',
      type: 'text',
      required: false,
      tab: 1,
      value: '',
      showWhenModal: ({ values }) => canShowInspectionDescription(values?.inspectionTypeId)
    },
    {
      header: 'Vendor',
      accessorKey: 'vendorId',
      nameKey: 'companyName',
      type: 'advanced-search',
      searchInfo: vendorSearchInfo(vendors),
      required: true,
      tab: 1
    }
  ];
};

export const createInspectionsFormTab = () => {
  return [{ header: 'Inspections', order: 1, iconPath: ['fas', 'file-contract'] }];
};

export const createVendorFormTab = () => {
  return [{ header: 'Vendor Info', order: 1, iconPath: ['fas', 'person-walking-luggage'] }];
};
export const createPostRequest = (values, authId, homesaleId) => {
  const request = { ...values };
  request.orderedDate = values.orderedDate === '' ? null : values.orderedDate;
  request.appointmentDate = values.appointmentDate === '' ? null : values.appointmentDate;
  request.receivedDate = values.receivedDate === '' ? null : values.receivedDate;
  request.cancelledDate = values.cancelledDate === '' ? null : values.cancelledDate;
  request.authorizationId = authId;
  request.homesaleId = homesaleId;
  request.inspectionDescription = normalizeInspectionDescription(values.inspectionDescription);
  return request;
};

export const createInspectionPutRequest = (selectedInspection, values, authId, homesaleId) => {
  const request = { ...selectedInspection };
  request.authorizationId = authId;
  request.homesaleId = homesaleId;
  request.orderedDate = values.orderedDate === '' ? null : values.orderedDate;
  request.appointmentDate = values.appointmentDate === '' ? null : values.appointmentDate;
  request.receivedDate = values.receivedDate === '' ? null : values.receivedDate;
  request.cancelledDate = values.cancelledDate === '' ? null : values.cancelledDate;
  request.repairAmount = values.repairAmount;
  request.repairedDate = values.repairedDate;
  request.deductFromEquity = values.deductFromEquity;
  request.paidDate = values.paidDate;
  request.statusId = values.statusId;
  request.requiredBy = values.requiredBy ?? '';
  request.areRepairsCompleted = values.areRepairsCompleted === true;
  request.areReceiptsReceived = values.areReceiptsReceived === true;
  request.isMorrealeNotified = values.isMorrealeNotified === true;
  request.comments = values.comments;
  request.inspectionDescription = normalizeInspectionDescription(values.inspectionDescription);

  return request;
};

export const createOrderInspectionSentRequest = (selectedInspection, authId) => {
  const request = { ...selectedInspection };
  request.authorizationId = authId;
  request.isInspectionSent = true;
  return request;
};

export const createVendorInfoPutRequest = (existingValues, values, authId, homesaleId) => {
  const request = { ...existingValues };
  request.authorizationId = authId;
  request.homesaleId = homesaleId;
  request.brokerId = values?.agentId ?? existingValues?.brokerId ?? null;
  request.inspectorId = values?.homesaleInspetorId ?? existingValues?.inspectorId ?? null;

  return request;
};

export const brokerSearchInfo = brokers => {
  //const enrichedBrokers = enrichAdvanceSearch(brokers);

  const searchingColumns = [
    { name: 'vendorId', title: 'Id' },
    { name: 'companyName', title: 'Company Name' }
  ];
  const searchingColumnExtensions = [
    { columnName: 'vendorId', width: 125 },
    { columnName: 'companyName', width: 150 }
  ];

  return {
    searchingColumns: searchingColumns,
    searchingColumnExtensions: searchingColumnExtensions,
    searchingRows: brokers,
    idKey: 'vendorId',
    nameKey: 'companyName'
  };
};

const inspectorSearchInfo = inspectors => {
  const enrichedInspectors = enrichAdvanceSearch(inspectors);
  return {
    searchingColumns: [
      { name: 'homesaleInspetorId', title: 'Inspector Id' },
      { name: 'vendorId', title: 'Vendor Id' },
      { name: 'fullName', title: 'Full Name' },
      { name: 'phone', title: 'Contact Phone' },
      { name: 'email', title: 'Contact Email' }
    ],
    searchingColumnExtensions: [
      { columnName: 'homesaleInspetorId', width: 150 },
      { columnName: 'vendorId', width: 150 },
      { columnName: 'fullName', width: 200 },
      { columnName: 'phone', width: 175 },
      { columnName: 'email', width: 175 }
    ],
    searchingRows: enrichedInspectors,
    idKey: 'homesaleInspetorId',
    nameKey: 'fullName'
  };
};

export const createVendorInfoFormFields = (inspection, brokers, inspectors, vendors) => {
  const broker = brokers?.find(b => b.agentId === inspection?.brokerId);
  const inspector = inspectors?.find(i => i.homesaleInspetorId === inspection?.inspectorId);
  const vendor = vendors && broker ? vendors.find(s => s.vendorId === broker.vendorId) : null;

  return [
    {
      header: 'Broker',
      accessorKey: 'agentId',
      nameKey: 'fullName',
      nameValue: FormatPersonName(broker),
      type: 'advanced-search',
      searchInfo: brokerSearchInfo(brokers),
      required: false,
      value: broker?.agentId,
      tab: 1,
      hideInTable: true
    },
    {
      header: 'Inspector',
      accessorKey: 'homesaleInspetorId',
      nameKey: 'fullName',
      nameValue: FormatPersonName(inspector),
      type: 'advanced-search',
      searchInfo: inspectorSearchInfo(inspectors),
      required: false,
      value: inspector?.homesaleInspetorId,
      tab: 1,
      hideInTable: true
    },
    {
      header: 'Inspection Company',
      accessorKey: 'companyName',
      type: 'text',
      required: false,
      value: inspector?.companyName,
      tab: 1,
      hideInModal: true
    },
    {
      header: 'Inspection Contact',
      accessorKey: 'inspectorFullName',
      type: 'text',
      required: false,
      value: FormatPersonName(inspector),
      tab: 1,
      hideInModal: true
    },
    {
      header: 'Broker Code',
      accessorKey: 'brokerCode',
      type: 'text',
      required: false,
      value: broker?.code,
      tab: 1,
      hideInModal: true
    },
    {
      header: 'Broker Company',
      accessorKey: 'companyName',
      type: 'text',
      required: false,
      value: vendor?.companyName || '',
      tab: 1,
      hideInModal: true
    },
    {
      header: 'Brokage Contact',
      accessorKey: 'brokerFullName',
      type: 'text',
      required: false,
      value: FormatPersonName(broker),
      tab: 1,
      hideInModal: true
    }
  ];
};

const enrichAdvanceSearch = contacts =>
  (contacts ?? []).map(c => {
    const fullName = FormatPersonName(c);
    return {
      ...c,
      fullName
    };
  });

export const FormatPersonName = person => (person ? `${person.firstName} ${person.lastName}` : '');

export const normalizeInspectionForForms = inspection => ({
  ...inspection,
  agentId: inspection?.brokerId ?? null,
  homesaleInspetorId: inspection?.inspectorId ?? null
});
